import { Follow } from '../models';
import { FollowRepository } from '../repositories';
import { logger } from '@/src/core/utils';

export class FollowUserUseCase {
  constructor(private followRepository: FollowRepository) {}

  async execute(followerId: string, followingId: string): Promise<Follow> {
    logger.debug('FollowUser', 'Following user', { followerId, followingId });

    // Check if already following
    const isFollowing = await this.followRepository.isFollowing(followerId, followingId);
    if (isFollowing) {
      throw new Error('Already following this user');
    }

    const follow = await this.followRepository.follow(followerId, followingId);

    logger.debug('FollowUser', 'Successfully followed user');

    return follow;
  }
}
